import { createAction } from '@reduxjs/toolkit';

import {
  DOWNLOAD_SHIPPING_LABEL,
  GET_SHIPPING_LABEL,
  LOAD_EXTERNAL_CARRIERS,
  LOAD_LABELS,
} from './actionTypes';

export const loadLabels = createAction<{ fileId: string }>(LOAD_LABELS.BASE);
export const loadExternalCarriers = createAction(LOAD_EXTERNAL_CARRIERS.BASE);
export const getShippingLabel = createAction<{
  fileId: string;
  moduleDefinitionId: string;
  moduleInstanceId: string;
  trackingUrl: string;
}>(GET_SHIPPING_LABEL.BASE);
export const downloadShippingLabel = createAction<{
  fileId: string;
  label: { moduleDefinitionId: string; moduleInstanceId: string } | undefined;
  downloadWindow: Window | null;
}>(DOWNLOAD_SHIPPING_LABEL.BASE);
